export const serieInitialData = {
    component: null,
    analysisType: null,
};

export const defaultColors = ['#ff342f', '#4444ff', '#238b1e', '#ffa500'];
